import React from 'react'

import { CellsWithSpacer } from './CellsWithSpacer'

interface BadgeRowProps extends Omit<React.HTMLAttributes<HTMLTableRowElement>, 'className'> {
  children: React.ReactNode;
}

export function BadgeRow ({ children, ...props }: BadgeRowProps) {
  return (
    <tr {...props}>
      <td className='w-36 bg-white sticky left-0 z-[1]' />
      <CellsWithSpacer>{children}</CellsWithSpacer>
    </tr>
  )
}
